import React from 'react';
import GridMenuItem, { GridMenuItemProps } from '@components-clean/core/grid/grid-menu/grid-menu-item';

interface GridMenuProps {
    items: GridMenuItemProps[];
}

const GridMenu = ({ items }: GridMenuProps) => (
    <div className="k-d-flex">
        {items.map((item, index) => (
            <div key={item.title} className="k-ml-2.5">
                <GridMenuItem {...item} isLastMenuItem={index === items.length - 1} />
            </div>
        ))}
    </div>
);

export default GridMenu;
